const settings = {
  baseUrl: "http://www.jwjyy.com",
  systemName: "济万佳-源臻堂医药网",


  // footWrap
  SPDA: "湖南省药品监督管理局", //省药监局
  SPDAUrl: "https://mpa.hunan.gov.cn/",//省药监局网站

  ICP: "湘ICP备2024064290号-2A", //ICP备案证书号
  IGIS: "（湘）-经营性-2024-0040 号",
  customerAddress: "湘潭经开区和平街道白石东路21号华美嘉工谷壹号2号厂房0101001",
  Tel: "13875225709",
  mail: "E-mail:1615885820@qq.com",

  QQ: "",

  company: "湖南源臻堂医药有限公司",
  bank: "中国农业银行湘潭九华支行",
  account: "18-192201040010680"


}

export default settings



// WEBPACK FOOTER //
// ./src/utils/config.js